import { faAngleDoubleLeft, faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog'
import { Toast } from 'primereact/toast'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { CertificateDocumentType } from '../../enums/CertificateDocumentType'
import {
  reloadCertificateList,
  selectCertificateList,
  selectIsLoadingCertificateList,
} from '../../features/certificateList/certificateListSlice'
import CertificateListService from '../../services/CertificateListService'
import CustomFilter from '../../shared/custom-filter/CustomFilter'
import LoadingIndicator from '../../shared/loading-indicator/LoadingIndicator'
import certificateRefinerColumns from '../../shared/refiners/data/certificate-refiner-columns'
import useToastr from './../../hooks/useToastr'
import CertificateListRefiners from './certificate-list-refiners/CertificateListRefiners'
import classes from './CertificateListView.module.scss'
import './CertificateListView.scss'
import TestReportMatchedFoundPopup from './cetificate-list/add-new-certificate/test-report-matched-found-popup/TestReportMatchedFoundPopup'
import { useTestReportValidator } from './cetificate-list/add-new-certificate/test-report-matched-found-popup/useTestReportValidator'
import {
  AttachmentUploadingErrorHeader,
  AttachmentUploadingErrorToastMessage,
  AttachmentUploadingSuccessHeader,
  AttachmentUploadingSuccessToastMessage,
  WithdrawalAttachmentUploadingSuccessHeader,
  WithdrawalAttachmentUploadingSuccessMessage,
  ActiveAttachmentUploadingSuccessHeader,
  ActiveAttachmentUploadingSuccessMessage,
  PendingWithdrawalSuccessHeader,
  PendingWithdrawalSuccessMessage,
} from './cetificate-list/certificate-details/shared/constants/CertificateUploadToastMessages'
import CertificateListGrid from './cetificate-list/certificate-list-grid/CertificateListGrid'
import certificateCustomFilterColumns from './data/certificate-custom-filter-columns'
import certificateGridColumns from './data/certificate-grid-columns'
import { useSignalR } from '../../hooks/useSignalR'
import { ecmUnavailableHeader, ecmUnavailableMessage } from '../../utils/constants/ecm.constants'
import CertificateDetailsV2 from './cetificate-list/certificate-details/CertificateDetailsV2'
import useRefinerEvent from './hooks/useRefinerEvent'
const CertificateListView = () => {
  const isReadOnly = new URL(window.location.href).searchParams.get('isReadOnly') === 'true'
  const toast = useRef(null)
  const dispatch = useDispatch()
  const testReportsValidatorHook = useTestReportValidator()
  const [certListData, setCertListData] = useState([])
  const [certListColumns, setCertListColumns] = useState(certificateGridColumns)
  const [certFrozenCount, setCertFrozenCount] = useState(1)
  const [refinerColumns, setRefinerColumns] = useState(certificateRefinerColumns)
  const [activeCount, setActiveCount] = useState([])
  const [expiringSoonCount, setExpiringSoonCount] = useState([])
  const [withDrawnCount, setWithDrawnCount] = useState([])
  const [underRevisionCount, setUnderRevisionCount] = useState([])
  const [obsoleteCount, setObsoleteCount] = useState([])
  const [totalCertificateCount, setTotalCertificateCount] = useState([])
  const [totalPageCount, setTotalPageCount] = useState(1)
  const [pageCount, setPageCount] = useState(100)
  const [currentPage, setCurrentPage] = useState(1)
  const [customFilters, setCustomFilters] = useState([])
  const [refiners, setRefiners] = useState([])
  const [statusRefiners, setStatusRefiners] = useState([])
  const [statusListRefiners, setStatusListRefiners] = useState([])
  const [hasRefiners, setHasRefiners] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isRefinerVisible, setRefinerVisible] = useState(true)
  const [lazyParams, setLazyParams] = useState({
    first: 1,
    last: 100,
    rows: 100,
    page: 1,
    isFirstPageLinkDisabled: false,
    isPrevPageLinkDisabled: false,
    isNextPageLinkDisabled: false,
    isLastPageLinkDisabled: false,
  })
  const [globalSearchText, setGlobalSearchText] = useState('')
  const [favoriteName, setFavoriteName] = useState('')
  const [favoriteList, setFavoriteList] = useState([])
  const [showCertificateDetails, setShowCertificateDetails] = useState(false)
  const globalSearchTextRef = useRef()
  const currentPageRef = useRef()
  const { showSuccess, showError, showWarning } = useToastr()
  const { isReloadGrid } = useSelector(selectCertificateList)
  const isLoading = useSelector(selectIsLoadingCertificateList)
  const [isConfirmDialogShow, setIsConfirmDialogShow] = useState(false)
  const [rowForActivation, setRowForActivation] = useState(null)
  const [testReportValidationOutput, setTestReportValidationOutput] = useState(null)
  const [clearSelectedValues, setClearSelectedValues] = useState(false)
  const refinerEvent = useRefinerEvent()
  const history = useHistory()
  const location = useLocation()
  const alreadyHandledRef = useRef(false)
  const getUrlPathCertificateNumber = () => {
    const search = location.search || ''
    const params = new URLSearchParams(search)
    const certificateNumber = params.get('certificateNumber')

    return certificateNumber
  }

  const removeCertificateNumberFromUrl = () => {
    const params = new URLSearchParams(location.search)
    if (!params.has('certificateNumber')) return

    params.delete('certificateNumber')
    history.replace({
      pathname: location.pathname,
      search: params.toString() ? `?${params.toString()}` : '',
    })

    window.parent.postMessage(
      { type: 'UNSAVED_CHANGES', value: false },
      '*'
    )
  }

  const hubUrl = process.env.REACT_APP_GMAE2E_FUNC_URL + '/api'
  const { connection: signalRConnection } = useSignalR(hubUrl, true)

  const handleCertificateRPSignalR = useCallback(
    (isSuccess, result, updatedCertListData, isAttachment) => {
      if (!result) return

      const parsedResult = JSON.parse(result)
      const certificate = updatedCertListData.find(
        cert =>
          cert.certificateName?.toLowerCase() === parsedResult?.certificateNumber?.toLowerCase()
      )

      if (!certificate) return
      if (isSuccess === true) {
        if (isAttachment === true) {
          showSuccess(AttachmentUploadingSuccessHeader, AttachmentUploadingSuccessToastMessage)
        } else {
          const isWithdrawn = certificate?.certStatus === 'Withdrawn'
          const isPendingWithdrawal =
            certificate?.withdrawalDate !== '' && new Date(certificate?.withdrawalDate) > new Date()

          const messageHeader =
            isWithdrawn || isPendingWithdrawal
              ? AttachmentUploadingSuccessHeader
              : ActiveAttachmentUploadingSuccessHeader

          const messageBody =
            isWithdrawn || isPendingWithdrawal
              ? AttachmentUploadingSuccessToastMessage
              : ActiveAttachmentUploadingSuccessMessage

          showSuccess(messageHeader, messageBody)
        }
      } else {
        showWarning(AttachmentUploadingErrorHeader, AttachmentUploadingErrorToastMessage)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [certListData]
  )

  useEffect(() => {
    if (signalRConnection) {
      signalRConnection.on('ecm-uploading-certificate-success', result =>
        showSuccess(AttachmentUploadingSuccessHeader, AttachmentUploadingSuccessToastMessage)
      )

      signalRConnection.on('ecm-uploading-certificate-failed', result =>
        showWarning(AttachmentUploadingErrorHeader, AttachmentUploadingErrorToastMessage)
      )

      signalRConnection.on('ecm-uploading-certificate-rp-success', result => {
        handleCertificateRPSignalR(true, result, certListData, false)
      })
      signalRConnection.on('ecm-uploading-certificate-rp-failed', result => {
        handleCertificateRPSignalR(false, result, certListData, false)
      })
      signalRConnection.on('ecm-uploading-certificate-rp-attachment-success', result => {
        handleCertificateRPSignalR(true, result, certListData, true)
      })
      signalRConnection.on('ecm-uploading-certificate-rp-attachment-failed', result => {
        handleCertificateRPSignalR(false, result, certListData, true)
      })

      signalRConnection.on('ecm-uploading-certificate-rp-pendingdocument-success', result =>
        showSuccess(AttachmentUploadingSuccessHeader, AttachmentUploadingSuccessToastMessage)
      )

      signalRConnection.on('ecm-uploading-certificate-rp-pendingdocument-failed', result =>
        showWarning(AttachmentUploadingErrorHeader, AttachmentUploadingErrorToastMessage)
      )
    }

    return () => {
      if (signalRConnection) {
        signalRConnection.off('ecm-uploading-certificate-success')
        signalRConnection.off('ecm-uploading-certificate-failed')
        signalRConnection.off('ecm-uploading-certificate-rp-success')
        signalRConnection.off('ecm-uploading-certificate-rp-failed')
        signalRConnection.off('ecm-uploading-certificate-rp-attachment-success')
        signalRConnection.off('ecm-uploading-certificate-rp-attachment-failed')
        signalRConnection.off('ecm-uploading-certificate-rp-pendingdocument-success')
        signalRConnection.off('ecm-uploading-certificate-rp-pendingdocument-failed')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signalRConnection, handleCertificateRPSignalR])

  const getCertificateListDataFromAllStates = () => {
    const certificateNumberRefiners = getUrlCertificateNumberRefiners()

    if (certificateNumberRefiners.length > 0) {
      setGlobalSearchText('')
      setCustomFilters([])
      setCurrentPage(1)
      setRefiners(certificateNumberRefiners)
      setStatusRefiners([])

      getCertificateListData('', pageCount, 1, [], certificateNumberRefiners, [], lazyParams)
      return
    }

    getCertificateListData(
      globalSearchText,
      pageCount,
      currentPage,
      customFilters,
      refiners,
      statusRefiners
    )
  }

  const getDefaultSettings = () => {
    getFavorites()
  }

  const getUrlCertificateNumberRefiners = () => {
    const urlCertificateNumber = getUrlPathCertificateNumber()
    return urlCertificateNumber
      ? [
        {
          Id: 'certificateNumber',
          Value: urlCertificateNumber,
          DisplayText: urlCertificateNumber,
        },
      ]
      : []
  }

  const getFavorites = async function (favoriteId = 0) {
    let favorites = await CertificateListService.getFavorites(4)
    if (!favorites) {
      favorites = []
    }
    const defaultFavorite =
      favoriteId > 0
        ? favorites.find(f => f.savedViewFavoriteId === favoriteId)
        : favorites.find(f => f.isDefault)

    const settings = defaultFavorite ? JSON.parse(defaultFavorite.settings) : null
    const frozenCount = settings?.certListColumns?.filter(f => f.isFrozen).length ?? 0
    const params = lazyParams
    params.rows = settings?.pageCount || 100
    const urlCertificateNumber = getUrlPathCertificateNumber()

    if (urlCertificateNumber) {
      const certificateNumberRefiners = [
        {
          Id: 'certificateNumber',
          Value: urlCertificateNumber,
          DisplayText: urlCertificateNumber,
        },
      ]

      getCertificateListData('', params.rows, 1, [], certificateNumberRefiners, [], params)
      removeCertificateNumberFromUrl()
      alreadyHandledRef.current = true

      setCertListColumns(settings?.certListColumns || certificateGridColumns)
      setCertFrozenCount(frozenCount)
      setGlobalSearchText('')
      setPageCount(params.rows)
      setCurrentPage(1)
      setCustomFilters([])
      setRefiners(certificateNumberRefiners)
      setStatusRefiners([])
      setFavoriteName('')

      if (globalSearchTextRef.current) {
        globalSearchTextRef.current.value = ''
      }
    } else if (defaultFavorite) {
      if (!settings.statusRefiners) {
        settings.statusRefiners = []
      }

      getCertificateListData(
        settings.globalSearchText,
        settings.pageCount,
        currentPage,
        settings.customFilters,
        settings.refiners,
        settings.statusRefiners,
        params
      )

      setCertListColumns(settings.certListColumns)
      setCertFrozenCount(frozenCount)
      setGlobalSearchText(settings.globalSearchText)
      setPageCount(settings.pageCount)
      setCustomFilters(settings.customFilters)
      setRefiners(settings.refiners)
      setFavoriteName(defaultFavorite.description)

      if (globalSearchTextRef.current) {
        globalSearchTextRef.current.value = settings.globalSearchText
      }
    } else {
      onClearFilters()
    }

    setFavoriteList(favorites)
  }

  const onSaveFavorite = (description, isDefault) => {
    const settings = {}
    settings.certListColumns = certListColumns
    settings.globalSearchText = globalSearchText
    settings.customFilters = customFilters
    settings.refiners = refiners
    settings.statusRefiners = statusRefiners
    settings.pageCount = pageCount

    const data = {}
    data.description = description
    data.isDefault = isDefault
    data.savedViewTypeId = 4
    data.settings = JSON.stringify(settings)

    saveFavorites(data)
  }

  const onEditFavorite = (id, description, isDefault) => {
    const data = favoriteList.find(f => f.savedViewFavoriteId === id)
    data.description = description
    data.isDefault = isDefault

    saveFavorites(data, 'updated')
  }

  const onDeleteFavorite = id => {
    const data = favoriteList.find(f => f.savedViewFavoriteId === id)
    data.isDeleted = true

    saveFavorites(data, 'deleted')
  }

  const saveFavorites = async function (data, transaction = 'saved') {
    const result = await CertificateListService.saveFavorites(data)

    showSuccess('Success', `Favorite has been successfully ${transaction}`)
    getFavorites(result)
  }

  const onClickFavorites = id => {
    getFavorites(id)
  }

  const enablerAction = () => {
    setRefinerVisible(!isRefinerVisible)
  }

  const onClearFilters = () => {
    const params = lazyParams
    params.first = 1
    params.rows = 100
    params.page = 1
    params.last = 100

    getCertificateListData('', 100, 1, [], [], [], params)

    setGlobalSearchText('')
    setPageCount(100)
    setCurrentPage(1)
    setCustomFilters([])
    setRefiners([])
    setStatusRefiners([])
    setFavoriteName('')
    currentPageRef.current.value = '1'

    if (globalSearchText.current) globalSearchTextRef.current.value = ''
  }

  const getCertificateListData = async function (
    globalSearchParam,
    pageCountParam,
    currentPageParam,
    customFiltersParam,
    refinersParam,
    statusRefinersParam = statusRefiners,
    lazyParam = lazyParams
  ) {
    setLoading(true)

    lazyParam.first = lazyParam.first === 0 ? 1 : lazyParam.first
    lazyParam.last = lazyParam.last === 0 ? lazyParam.rows : lazyParam.last
    lazyParam.page = lazyParam.page === 0 ? 1 : lazyParam.page
    currentPageParam = currentPageParam === 0 ? 1 : currentPageParam

    const certificateNumberRefiners = getUrlCertificateNumberRefiners()
    let currentRefiners = certificateNumberRefiners.length > 0 ? certificateNumberRefiners : refinersParam
    if (certificateNumberRefiners.length > 0) {
      globalSearchParam = ''
      customFiltersParam = []
      currentPageParam = 1
      setGlobalSearchText('')
      setCustomFilters([])
      setCurrentPage(1)
      setRefiners(certificateNumberRefiners)
      setStatusRefiners([])
    } else {
      if (currentRefiners.length === 0) {
        currentRefiners = statusRefinersParam
      } else {
        setStatusRefiners([])
      }
    }

    const result = await CertificateListService.getCertificateListData({
      GlobalSearch: globalSearchParam,
      PageCount: pageCountParam,
      CurrentPage: currentPageParam,
      CustomFilters: customFiltersParam,
      Refiners: currentRefiners,
    })

    if (
      result &&
      result.certificate &&
      Array.isArray(result.certificate) &&
      result.certificate.length > 0
    ) {
      const totalPage = Math.ceil(result.totalCount / pageCountParam)
      setTotalPageCount(totalPage)
      setCertListData(result.certificate)
      setTotalCertificateCount(result.totalCount)

      lazyParam.last = pageCountParam * currentPageParam
      if (lazyParam.last > parseInt(result.totalCount)) {
        lazyParam.last = parseInt(result.totalCount)
      }

      pageChange(lazyParam, totalPage)
    } else {
      setTotalPageCount(0)
      setCertListData(result.certificate)
      setTotalCertificateCount(0)

      if (currentPageParam > 1) {
        lazyParam.first = 1
        lazyParam.last = lazyParam.rows
        lazyParam.page = 1

        getCertificateListData(
          globalSearchParam,
          pageCountParam,
          1,
          customFiltersParam,
          refinersParam,
          statusRefinersParam,
          lazyParam
        )
      } else {
        lazyParam.first = 0
        lazyParam.last = 0
        lazyParam.page = 0

        pageChange(lazyParam)
      }
    }

    if (refinersParam.length > 0) {
      setHasRefiners(true)
    } else {
      setHasRefiners(false)
    }

    setLoading(false)
  }

  const getCertificateStatistics = async function () {
    const result = await CertificateListService.getCertificateStatistics()
    if (result) {
      setActiveCount(result.active)
      setExpiringSoonCount(result.expiringSoon)
      setWithDrawnCount(result.withdrawn)
      setUnderRevisionCount(result.underRevision)
      setObsoleteCount(result.obsolete)

      const total =
        parseInt(result.active) +
        parseInt(result.withdrawn) +
        parseInt(result.underRevision) +
        parseInt(result.obsolete)

      setTotalCertificateCount(total)
    }
  }

  const replaceFilterBySelected = (value, refinerId) => {
    if (!value || !value.name) return

    setRefiners(prevState => {
      let newState = JSON.parse(JSON.stringify(prevState))
      newState = newState.filter(i => i.Id !== refinerId)

      newState.push({
        Id: refinerId,
        Value: value.name,
        DisplayText: value.name,
      })

      getCertificateListData(globalSearchText, pageCount, currentPage, customFilters, newState)

      return newState
    })
  }

  const addSelectedToYourFilters = (value, refinerId) => {
    if (refinerId === 'status') {
      if (value === null) return // prevent toggling submission
      const newSelectedStatus = value.map(item => ({
        Id: refinerId,
        Value: item.name,
        DisplayText: item.name,
      }))

      /**
       * Prevents no changes toggling submission
       */
      const prevSelectedStatus = refiners.filter(item => item.Id === refinerId)
      if (
        newSelectedStatus.every(item => prevSelectedStatus.some(val => val.Value === item.Value)) &&
        newSelectedStatus.length === prevSelectedStatus.length
      )
        return

      setRefiners(prevState => {
        let newState = prevState.filter(i => i.Id !== refinerId)

        newState.push(...newSelectedStatus)

        getCertificateListData(globalSearchText, pageCount, currentPage, customFilters, newState)
        return newState
      })
      return
    }

    if (value && Array.isArray(value) && value.length > 0) {
      setRefiners(prevState => {
        let newState = JSON.parse(JSON.stringify(prevState))
        value.forEach(item => {
          var existingRefiner = prevState.find(i => i.Value === item.name && i.Id === refinerId)
          if (!existingRefiner) {
            newState.push({
              Id: refinerId,
              Value: item.name,
              DisplayText: item.name,
            })
          }
        })

        getCertificateListData(globalSearchText, pageCount, currentPage, customFilters, newState)
        return newState
      })
    } else if (value && value.name && value.code) {
      setRefiners(prevState => {
        let newState = []
        let existingRefiner = null

        if (prevState) {
          newState = JSON.parse(JSON.stringify(prevState))
          existingRefiner = prevState.find(i => i.Value === value.name && i.Id === refinerId)
        }
        if (!existingRefiner) {
          newState.push({
            Id: refinerId,
            Value: value.name,
            DisplayText: value.name,
          })
        }

        getCertificateListData(globalSearchText, pageCount, currentPage, customFilters, newState)
        return newState
      })
    }
  }

  const onChangeDatePickerRefiner = (value, refinerId) => {
    if (value && value.Value && value.Condition) {
      setRefiners(prevState => {
        var newState = JSON.parse(JSON.stringify(prevState))
        newState = newState.filter(i => !(i.Condition === value.Condition && i.Id === refinerId))

        newState.push({
          Id: refinerId,
          Value: value.Value,
          Condition: value.Condition,
          DisplayText: value.DisplayText,
        })

        getCertificateListData(globalSearchText, pageCount, currentPage, customFilters, newState)
        return newState
      })
    }
  }

  const onClickRemoveRefinerGroup = refinerId => {
    setRefiners(prevState => {
      const stateTemp = prevState.filter(i => i.Id !== refinerId)
      if (refinerId === 'status') setStatusListRefiners(stateTemp)

      getCertificateListData(globalSearchText, pageCount, currentPage, customFilters, stateTemp)
      return stateTemp
    })
  }

  const onClickRemoveRefiner = (item, isCompareFromValue = true) => {
    setRefiners(prevState => {
      let stateTemp

      if (isCompareFromValue) {
        stateTemp = prevState.filter(i => !(i.Value === item.Value && i.Id === item.Id))
      } else {
        stateTemp = prevState.filter(i => !(i.Condition === item.Condition && i.Id === item.Id))
      }

      setStatusListRefiners(stateTemp.filter(i => i.Id === 'status'))
      getCertificateListData(globalSearchText, pageCount, currentPage, customFilters, stateTemp)
      return stateTemp
    })
  }

  const onClickGlobalSearch = searchText => {
    getCertificateListData(searchText, pageCount, currentPage, customFilters, refiners)

    setGlobalSearchText(searchText)
  }

  const onClickStatusFilter = status => {
    setRefiners([])

    if (status) {
      const statusFilter = [
        {
          Id: 'status',
          Value: status,
        },
      ]

      getCertificateListData(
        globalSearchText,
        pageCount,
        currentPage,
        customFilters,
        [],
        statusFilter
      )

      setStatusRefiners(statusFilter)
    } else {
      getCertificateListData(globalSearchText, pageCount, currentPage, customFilters, [], [])

      setStatusRefiners([])
    }
  }

  const onChangePage = params => {
    params.first = (params.page - 1) * params.rows + 1
    const last = params.page * params.rows
    params.last = last > totalCertificateCount ? totalCertificateCount : last

    getCertificateListData(
      globalSearchText,
      params.rows,
      params.page,
      customFilters,
      refiners,
      statusRefiners,
      params
    )
  }

  const pageChange = (params, totalPages = 0) => {
    if (params.page > 1) {
      params.isFirstPageLinkDisabled = false
      params.isPrevPageLinkDisabled = false
    } else {
      params.isFirstPageLinkDisabled = true
      params.isPrevPageLinkDisabled = true
    }

    if (params.page < totalPages) {
      params.isLastPageLinkDisabled = false
      params.isNextPageLinkDisabled = false
    } else {
      params.isLastPageLinkDisabled = true
      params.isNextPageLinkDisabled = true
    }

    setPageCount(params.rows)
    setCurrentPage(params.page)
    setLazyParams(params)
    currentPageRef.current.value = params.page
  }

  const onClickClearYourFilters = () => {
    setRefiners([])
    getCertificateListData(globalSearchText, pageCount, currentPage, customFilters, [])
  }

  const onClickSetCustomFilters = () => {
    if (customFilters && Array.isArray(customFilters) && customFilters.length > 0) {
      getCertificateListDataFromAllStates()
    }
  }

  const onClickClearCustomFilters = () => {
    setCustomFilters([])
    getCertificateListData(globalSearchText, pageCount, currentPage, [], refiners)
  }
  useEffect(() => {
    setClearSelectedValues(!refiners.length)
  }, [refiners])

  useEffect(() => {
    getCertificateStatistics()
    getDefaultSettings()

    refinerEvent.subscribe(data => {
      setRefiners(
        Object.entries(data).map(([key, value]) => ({
          Id: key,
          Value: value,
          DisplayText: value,
        }))
      )

      setGlobalSearchText('')
      if (globalSearchTextRef.current) {
        globalSearchTextRef.current.value = ''
      }
    })
    return () => {
      refinerEvent.destroy()
    }
  }, [])

  useEffect(() => {
    if (isReloadGrid) {
      getCertificateListDataFromAllStates()
      dispatch(reloadCertificateList(false))
    }
  }, [isReloadGrid])

  useEffect(() => {
    const certificateNumber = getUrlPathCertificateNumber()
    if (!certificateNumber || alreadyHandledRef.current) return

    alreadyHandledRef.current = true
    const certificateNumberRefiners = [
      {
        Id: 'certificateNumber',
        Value: certificateNumber,
        DisplayText: certificateNumber,
      },
    ]

    setGlobalSearchText('')
    setCustomFilters([])
    setCurrentPage(1)
    setRefiners(certificateNumberRefiners)
    setStatusRefiners([])

    getCertificateListData('', pageCount, 1, [], certificateNumberRefiners, [], lazyParams)
    removeCertificateNumberFromUrl()
  }, [location.search])

  const onActivateCertificate = async row => {
    const certificateId = row.certificateId

    if (row.certificateStatus != 'Under Revision') return

    const certDetailsResp =
      await CertificateListService.getCertificateDetailsForActivation(certificateId)

    if (!certDetailsResp.isSuccess) return

    let certDetails = certDetailsResp.data

    if (!certDetails || certDetails.certificateStatus != 'Under Revision') return

    const data = {
      certificateId: certificateId,
      skipValidation: true,
      projectNumber: certDetails.projectNumber,
    }
    setRowForActivation(data)

    if (certDetails.hasValidAttachments && certDetails.hasBaseModel) {
      setIsConfirmDialogShow(true)
    } else {
      await activateCertificate(data)
    }
  }

  const onWithdrawCertificate = row => {
    const data = {
      certificateId: row.certificateId,
      skipValidation: true,
      projectNumber: row.projectNumber,
    }

    withdrawCertificate(data)
  }

  const proceedActivationWithDuplicate = async () => {
    testReportsValidatorHook.setTestReportMatchedFoundPopupVisible(false)
    await activateCertificate(rowForActivation)
  }

  const validateTestReport = async () => {
    const certificateDetailFromWb =
      await CertificateListService.getCertificateDetailByWorkbenchCertificateId(
        rowForActivation?.certificateId
      )

    const certificateDetailsWithDocuments =
      await CertificateListService.getCertificateDetailsWithDocuments(
        certificateDetailFromWb?.data?.id
      )

    var duplicateTestReportRows =
      certificateDetailsWithDocuments?.data?.certificateDocuments.filter(
        attachment => attachment.documentType === CertificateDocumentType.TestReport
      )

    let ownerReference = certificateDetailFromWb.data.partySiteNumber

    let scheme = certificateDetailFromWb.data.certificationScheme

    let baseModel = certificateDetailFromWb.data.baseModel

    let filesToValidate = duplicateTestReportRows.map(file => file.originalFileName)

    var validationResult = await testReportsValidatorHook.validateTestReports(
      filesToValidate,
      ownerReference,
      scheme,
      baseModel
    )

    if ((await validationResult).hasDuplicate > 0) {
      testReportsValidatorHook.setTestReportMatchedFoundPopupVisible(true)
      setTestReportValidationOutput(validationResult.matchedTestReports)
    } else {
      await activateCertificate(rowForActivation)
    }
  }

  const activateCertificate = async data => {
    setLoading(true)
    data = !data ? rowForActivation : data

    const result = await CertificateListService.activateCertificate(data)
    if (result.isSuccess === true) {
      await processCertificateDetailsUpdate(data.certificateId)
    } else {
      setLoading(false)
      showError('Error', result.message)
    }
  }

  const processCertificateDetailsUpdate = async certificateId => {
    const result = await CertificateListService.updateActivatedCertificateDetails(certificateId)
    showSuccess('Success', 'Certificate activated successfully')
    getCertificateListDataFromAllStates()
    setLoading(false)
    if (!result.isSuccess) {
      showWarning(ecmUnavailableHeader, ecmUnavailableMessage)
    }
  }

  const withdrawCertificate = async function (data) {
    const result = await CertificateListService.withdrawCertificate(data)
    if (result.isSuccess === true) {
      showSuccess('Success', 'Certificate withdrawn successfully')

      getCertificateListDataFromAllStates()
    } else {
      showError('Error', result.message)
    }
  }

  const handleDeleteCertificate = async data => {
    confirmDialog({
      message: () => {
        return (
          <>
            Are you sure you want to delete this record? This cannot be undone.
            <div className={classes['note']}>
              (Note: If this is a modification to an existing certificate, deleting this draft will
              revert the certificate to the most recent Active version).
            </div>
          </>
        )
      },
      header: 'Confirm Certificate Deletion',
      className: classes['delete-confirmation-dialog'],
      accept: async () => {
        setShowCertificateDetails(false)
        setLoading(true)

        const handleError = () => {
          showError('Error', 'There is an error processing your request. Please try again later.')
          setLoading(false)
        }

        try {
          const { isSuccess } = await CertificateListService.deleteIPCertificate(data.certificateId)

          if (isSuccess) {
            showSuccess('Success!', 'Certificate successfully deleted.')
            dispatch(reloadCertificateList(true))
          } else handleError()
        } catch {
          handleError()
        }
      },
    })
  }

  const confirmDialogBody = () => {
    return (
      <>
        <div className="custom-confirm-dialog-body">
          <div className="custom-space-below">
            File(s) will be saved to ECM TIC and cannot be deleted.
          </div>
          <div>Would you like to Continue?</div>
        </div>
      </>
    )
  }

  const confirmFooter = () => {
    return (
      <>
        <div className="custom-confirm-dialog-footer">
          <button
            className="ul-button -app-primary -medium custom-confirm-dialog-accept-btn"
            onClick={acceptConfirmDialog}
          >
            YES
          </button>
          <button
            className="ul-button -medium default-cancel-button custom-confirm-dialog-reject-btn"
            onClick={rejectConfirmDialog}
          >
            NO
          </button>
        </div>
      </>
    )
  }

  const acceptConfirmDialog = async () => {
    setIsConfirmDialogShow(false)
    await validateTestReport()
  }

  const rejectConfirmDialog = () => {
    setIsConfirmDialogShow(false)
  }

  return (
    <>
      <LoadingIndicator isLoading={isLoading} />
      <div className="ul-grid__row cert-list-view-container">
        {isRefinerVisible ? (
          <div className="ul-grid__column -x20 -offset-10-desktop -x100-mobile cert-search-and-refiners-area">
            <CustomFilter
              globalSearchTextRef={globalSearchTextRef}
              columns={certificateCustomFilterColumns}
              conditions={['Contains', 'Equal']}
              customFilters={customFilters}
              setCustomFilters={setCustomFilters}
              onClickSetCustomFilters={onClickSetCustomFilters}
              onClickClearCustomFilters={onClickClearCustomFilters}
              refiners={refiners}
              refinerColumns={refinerColumns}
              hasRefiners={hasRefiners}
              onClickRemoveRefiner={onClickRemoveRefiner}
              onClickRemoveRefinerGroup={onClickRemoveRefinerGroup}
              onClickGlobalSearch={onClickGlobalSearch}
              onClickClearYourFilters={onClickClearYourFilters}
            />
            <CertificateListRefiners
              refiners={refiners}
              setRefiners={setRefiners}
              onClickRemoveRefiner={onClickRemoveRefiner}
              addSelectedToYourFilters={addSelectedToYourFilters}
              replaceFilterBySelected={replaceFilterBySelected}
              onChangeDatePickerRefiner={onChangeDatePickerRefiner}
              statusListRefiners={statusListRefiners}
              clearSelectedValues={clearSelectedValues}
            />
          </div>
        ) : null}

        <div className={!isRefinerVisible ? 'cert-list-grid-area-full' : 'cert-list-grid-area'}>
          <div className="enabler">
            <button
              title="Click here to show/hide"
              className={`${!isRefinerVisible ? 'hide' : ''}`}
              onClick={enablerAction}
            >
              {isRefinerVisible ? (
                <FontAwesomeIcon icon={faAngleDoubleLeft} />
              ) : (
                <FontAwesomeIcon icon={faAngleDoubleRight} />
              )}
            </button>
          </div>

          <CertificateListGrid
            isReadOnly={isReadOnly}
            loading={loading}
            setLoading={setLoading}
            currentPageRef={currentPageRef}
            certListData={certListData}
            columns={certListColumns}
            setColumns={setCertListColumns}
            refiners={refiners}
            statusRefiners={statusRefiners}
            customFilters={customFilters}
            globalSearchText={globalSearchText}
            frozenColCount={certFrozenCount}
            activeCount={activeCount}
            expiringSoonCount={expiringSoonCount}
            withDrawnCount={withDrawnCount}
            underRevisionCount={underRevisionCount}
            obsoleteCount={obsoleteCount}
            totalCertificateCount={totalCertificateCount}
            totalPageCount={totalPageCount}
            pageCount={pageCount}
            currentPage={currentPage}
            lazyParams={lazyParams}
            favoriteName={favoriteName}
            favoriteList={favoriteList}
            onClickStatusFilter={onClickStatusFilter}
            onChangePage={onChangePage}
            setCertListColumns={setCertListColumns}
            setCertFrozenCount={setCertFrozenCount}
            setShowCertificateDetails={setShowCertificateDetails}
            onSaveFavorite={onSaveFavorite}
            onEditFavorite={onEditFavorite}
            onDeleteFavorite={onDeleteFavorite}
            onClickFavorites={onClickFavorites}
            onClearFilters={onClearFilters}
            onActivateCertificate={onActivateCertificate}
            onWithdrawCertificate={onWithdrawCertificate}
            onDeleteCertificate={handleDeleteCertificate}
          />
        </div>

        {showCertificateDetails && (
          <CertificateDetailsV2
            isReadOnly={isReadOnly}
            onDeleteCertificate={handleDeleteCertificate}
            showCertificateDetails={showCertificateDetails}
            setShowCertificateDetails={setShowCertificateDetails}
          />
        )}
      </div>
      <Toast ref={toast} />
      <ConfirmDialog />
      <div>
        <ConfirmDialog
          style={{ width: '520px' }}
          className="custom-confirm-dialog"
          visible={isConfirmDialogShow}
          header="Save and Activate Confirmation"
          message={confirmDialogBody}
          footer={confirmFooter}
          onHide={() => rejectConfirmDialog()}
        />
      </div>

      <TestReportMatchedFoundPopup
        visible={testReportsValidatorHook.testReportMatchedFoundPopupVisible}
        onProceedWithoutDuplicate={() => {
          testReportsValidatorHook.setTestReportMatchedFoundPopupVisible(false)
        }}
        onProceedWithDuplicate={() => {
          proceedActivationWithDuplicate()
        }}
        onClose={() => {
          testReportsValidatorHook.setTestReportMatchedFoundPopupVisible(false)
        }}
        rows={testReportValidationOutput}
      />
    </>
  )
}
export default CertificateListView
